<template>
    <div class="flex justify-between">
        <div class="flex items-center gap-1">
            <label :for="'input-' + model.name">{{ t(`setting.${model.name}.title`) }}</label>
            <UTooltip
                v-if="shouldShowTooltip"
                :text="helpText"
                :delay-duration="0"
                :ui="{
                    content: 'h-fit overflow-visible',
                    text: 'whitespace-pre-line p-1',
                }"
            >
                <i class="i-ph-info inline-block" />
            </UTooltip>
        </div>
        <general-input
            :id="'input-' + model.name"
            v-model="innerValue"
            type="text"
            class="w-[200px]"
            :is-valid="validator"
            @blur="onBlur"
        />
    </div>
</template>

<script setup lang="ts">
import {Setting} from '@/setting/setting.service'
import {computed, PropType, ref} from 'vue'
import GeneralInput from '@/components/GeneralInput.vue'
import {useI18n} from 'vue-i18n'
import {SettingValidator} from '@/setting/SettingValidator'

const {t} = useI18n()

const model = defineModel<Setting<string>>({required: true})
defineProps({
    validator: {
        type: Function as PropType<SettingValidator>,
        required: false
    }
})
const innerValue = ref<string>(model.value.value ?? '')

const helpText = computed(() => {
    return t(`setting.${model.value.name}.tooltip`)
})

const shouldShowTooltip = computed(
    () => helpText.value !== ''
)

const onBlur = () => {
    model.value.value = innerValue.value
}

</script>

<style scoped>

</style>